import { defineComponent, ref } from 'vue';
import CommitteeTableComponent from '@/components/committeeTable/CommitteeTable.vue';
import CommitteeFormComponent from '@/components/committeeTable/committeeForm/CommitteeForm.vue';

export default defineComponent({
  name: 'CommitteePage',
  components: {
    CommitteeTableComponent,
    CommitteeFormComponent
  },
  setup: () => {
    const selectedCommitteeId = ref<number | null>();
    const committeeForm = ref<InstanceType<typeof CommitteeFormComponent>>();

    const createClick = () => {
      Promise.resolve(selectedCommitteeId.value = null)
        .then(() => committeeForm.value?.show());
    };

    const editClick = (carouselId: number) => {
      Promise.resolve(selectedCommitteeId.value = carouselId)
        .then(() => committeeForm.value?.show());
    };

    return {
      selectedCommitteeId,
      committeeForm,
      createClick,
      editClick,
    };
  },
});
